export enum EFormMode {
    ADD = 'ADD',
    EDIT = 'EDIT',
    VIEW = 'VIEW',
    DELETE = 'DELETE',
}
